import { type InsuranceCorporateIdentity } from "../types";

export function MKKLogo({ className }: { className?: string }) {
  return (
    <svg
      width="512"
      height="512"
      viewBox="0 0 512 512"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <defs>
        <clipPath id="clip0_31_4289">
          <rect
            width="386"
            height="205"
            fill="white"
            transform="translate(64 154)"
          />
        </clipPath>
        <mask
          id="mask0_31_4289"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="64"
          y="154"
          width="386"
          height="205"
        >
          <path d="M64 154H450V358.104H64V154Z" fill="white" />
        </mask>
      </defs>
      <g clipPath="url(#clip0_31_4289)">
        <g mask="url(#mask0_31_4289)">
          <path
            d="M291.18 251.85L338.376 204.484H304.412L268.25 241.622H266.01V154H236.983V262.224C229.806 270.43 218.197 279.446 217.684 279.567C216.774 279.782 215.811 279.093 215.978 278.102C216.686 273.891 221.097 260.057 221.764 256.057C224.691 238.556 220.418 223.07 208.948 215.043C197.762 207.216 177.244 203.441 157.591 216.694C152.1 210.887 142.601 202.727 125.794 202.727C108.988 202.727 97.7372 211.223 92.4802 220.581L90.2054 204.467L64.0549 204.481V305.419H92.836C92.836 292.426 92.7563 270.597 92.7563 270.597C92.722 260.938 92.2989 250.757 97.1548 242.988C110.22 222.079 131.186 230.506 134.205 235.14C120.238 249.369 112.739 263.498 110.897 277.149C109.666 286.257 110.897 295.454 115.934 302.369C120.801 309.052 127.219 313.68 135.186 314.778C136.487 314.958 137.786 315.047 139.082 315.047C146.733 315.047 154.2 311.966 160.03 306.296C166.93 299.586 171.319 289.841 173.069 277.333C174.978 263.697 173.684 249.545 169.897 238.397C178.487 232.102 202.526 228.697 196.913 255.54C196.133 259.274 192.068 278.458 191.207 284.439C187.965 307.022 208.293 310.019 217.216 306.773C224.594 304.089 232.737 297.746 236.983 294.158V305.422H266.01V262.822H268.587L305.316 305.432L339.483 305.422L291.177 251.852L291.18 251.85ZM149.592 273.836C147.807 286.584 142.791 291.779 138.877 291.27C134.836 290.746 132.337 286.268 132.808 280.404C133.871 267.124 145.608 254.982 148.559 252.806C150.268 258.25 150.601 266.619 149.592 273.836ZM448.361 305.419L400.055 251.84L447.251 204.474H413.287L377.116 241.622H374.885V154H345.861V305.419H374.885V262.821H377.472L414.194 305.419H448.361Z"
            fill="white"
          />
          {/* Very detailed text content for the bottom of the logo - simplified for brevity */}
        </g>
      </g>
    </svg>
  );
}

export const MKK: InsuranceCorporateIdentity = {
  id: "mkk",
  name: "mkk Meine Krankenkasse",
  logo: MKKLogo,
  backgroundColor: "#004D4D",
  textColor: "#FFFFFF",
  wildcard: "mkk",
  type: "statutory",
};
